import classes from './BlogBanner.module.css'
import Image from 'next/image'
import readTimeEstimate from 'read-time-estimate'
import parse from 'html-react-parser'
import clockImg from 'assets/icons/common/clock.svg'
import editPen from 'assets/icons/common/edit-pen-5.svg'
import Tag from '../../../tag'
import {BlogDetails} from 'types/blogs'
import {format} from 'date-fns'

interface BlogBannerProps {
  details: BlogDetails
}

const BlogBanner = ({details}: BlogBannerProps) => {
  const getBlogReadingTime = (string: string) => {
    const {humanizedDuration} = readTimeEstimate(string, 275, 12, 500, ['img', 'Image'])
    return humanizedDuration
  }
  return (
    <div className={classes.banner}>
      <div className={classes.firstSection}>
        <div className={classes.tags}>
          {((details?._embedded as any)['wp:term']?.[0] || []).map(
            (tag: {slug: string; name: string}) =>
              tag.name !== 'Recommended' ? (
                <Tag key={tag?.slug} text={tag.name} slug={tag?.slug} />
              ) : null,
          )}
        </div>
        <div>
          <h1 className={classes.title}>{parse(details?.title?.rendered || '')}</h1>
        </div>
        <div className={classes.authorSection}>
          <div className={classes.author}>
            <Image src={editPen} width={16} className={classes.icons} alt="" />
            {details?.date ? format(new Date(details?.date), 'dd MMMM, yyyy') : ''}
          </div>
          <div className={classes.divider}></div>
          <div className={classes.time}>
            <Image src={clockImg} width={16} className={classes.icons} alt="" />
            <div>{`${getBlogReadingTime(details?.content?.rendered) || '4 minutes'} read`}</div>
          </div>
        </div>
      </div>
      <div className={classes.secondSection}>
        <Image
          width={1000}
          height={800}
          alt="blog"
          src={details?.jetpack_featured_media_url}
          className={classes.blogImage}
        />
      </div>
    </div>
  )
}

export default BlogBanner
